export default __webpack_public_path__ + "static/media/fbi.1cc4fb76.jpg";